// Module
var code = "<a ng-href={{$ctrl.website.url}} target=_blank ng-click=$event.stopPropagation()> <i class=\"fas fa-globe\"></i> </a> ";
// Exports
module.exports = code;